import { render, staticRenderFns } from "./InviteAssistant.vue?vue&type=template&id=638a2425&scoped=true&"
import script from "./InviteAssistant.vue?vue&type=script&lang=js&"
export * from "./InviteAssistant.vue?vue&type=script&lang=js&"
import style0 from "./InviteAssistant.vue?vue&type=style&index=0&id=638a2425&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "638a2425",
  null
  
)

export default component.exports